export const PAGE_STATUS = {
  DRAFT: 'DRAFT',
  PUBLISH: 'PUBLISH',
};
